<template>
  <div class="knowledge-practice-list-page">
    <title-bar title="体育健康知识"> </title-bar>

    <div class="main" v-if="knowledgeList.length">
      <practice-card
        v-for="(training, index) in knowledgeList"
        :key="index"
        :training-info="training"
        @click="navToTrainingStatic(training)"
        @remove="handleRemove"
        @updateTime="showUpdatePopup(training)"
      ></practice-card>
    </div>
    <div class="empty" v-else>
      <img src="./assets/img_practice_empty@2x.png" />
      <el-button @click="navToRepo"> 从知识库布置</el-button>
    </div>
    <el-dialog
      width="486px"
      center
      title="调整练习时间"
      :visible.sync="updateTimePopupVisible"
      v-if="selectItem"
      class="update-exam-time-dialog"
    >
      <el-form inline>
        <el-form-item label="开始日期">
          <el-date-picker v-model="selectItem.start_datetime"></el-date-picker>
        </el-form-item>

        <el-form-item label="结束日期">
          <el-date-picker v-model="selectItem.end_datetime"></el-date-picker>
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button @click="updateTimePopupVisible = false"> 取消</el-button>
        <el-button type="primary" @click="updateChallenge"> 确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script lang="ts">
import { BasePage, Component } from 'kuaidong-component'
import TitleBar from '@/components/TitleBar.vue'
import { ITrainingListItem } from 'kuaidong-model'
import { DateUtil, DateWrapper } from 'kuaidong-lib'
import { AWinter2023 } from 'kuaidong-api'
import { KDMessageBox } from 'kuaidong-ui'
import UpdateNamePopup from '@/views/pe-knowledge/components/UpdateNamePopup.vue'
import PracticeCard from '@/views/pe-knowledge/components/PracticeCard.vue'
@Component({
  components: {
    TitleBar,
    PracticeCard,
    UpdateNamePopup,
  },
})
export default class KnowledgeExamListPage extends BasePage {
  knowledgeList: ITrainingListItem[] = []
  updateTimePopupVisible = false
  selectItem: ITrainingListItem | null = null

  async created() {
    this.fetchTrainingList()
  }

  async fetchTrainingList() {
    this.knowledgeList = await AWinter2023.challengeOrTrainingList('KNOWLEDGE')
  }

  navToTrainingStatic(training: ITrainingListItem) {
    this.$router.push({
      name: 'pe_knowledge_practice_clazz_detail',
      query: {
        training: JSON.stringify(training),
        from: 'KNOWLEDGE',
      },
    })
  }

  async handleRemove(trainingInfo: ITrainingListItem) {
    const ok = await KDMessageBox.confirm('', '是否删除该练习！', {
      cancelButtonText: '取消',
      confirmButtonText: '确认删除',
      confirmButtonType: 'danger',
    })
    if (ok) {
      try {
        await AWinter2023.deleteTeacherChallenge(trainingInfo.group_id)
        this.toast('删除练习成功~')
        this.fetchTrainingList()
      } catch (e) {
        this.toast('删除练习失败~')
      }
    }

    return
  }

  showUpdatePopup(selectItem: ITrainingListItem) {
    this.selectItem = selectItem
    this.updateTimePopupVisible = true
  }

  async updateChallenge() {
    if (this.validate()) {
      try {
        const form = {
          ...this.selectItem,
          end_datetime: DateUtil.endOfDay(new DateWrapper((this.selectItem as ITrainingListItem).end_datetime).date),
        }
        await AWinter2023.updateTeacherChallenge(form as ITrainingListItem)
        this.updateTimePopupVisible = false
        this.$message.success('时间已更新~')

        this.fetchTrainingList()
      } catch (e) {
        this.$message.error('更新时间发生错误~')
      }
    }
  }

  formatDate(date: Date) {
    return new DateWrapper(date).showDateWeekStr
  }

  validate() {
    if (this.selectItem) {
      const start = new DateWrapper(this.selectItem.start_datetime)

      if (this.selectItem.end_datetime) {
        const end = new DateWrapper(this.selectItem.end_datetime)
        if (end.date < start.date) {
          this.toast('结束时间不能小于开始时间~')
          return false
        }
      } else {
        this.toast('请选择结束时间~')
      }

      return true
    } else {
      return false
    }
  }

  navToRepo() {
    this.$router.push({ name: 'pe_knowledge_repo' })
  }
}
</script>
<style lang="less">
.knowledge-practice-list-page {
  > .main {
    padding: 16px;
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    > .practice-card-comp {
      margin-right: 20px;
      margin-bottom: 30px;
    }
  }
  > .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > img {
      width: 130px;
      height: 158px;
    }
    > .el-button {
      background: #ffffff;
      border: 1px solid var(--shs-theme-primary);
      border-radius: 4px;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      color: var(--shs-theme-primary);
      padding: 9px 38px;
      margin-top: 33px;
    }
  }

  > .update-exam-time-dialog {
    > .el-dialog {
      padding: 0 20px;

      > .el-dialog__header {
        font-weight: 500;
        font-size: 18px;
        line-height: 26px;
        color: #0a1629;
      }
      > .el-dialog__body {
        display: flex;
        flex-direction: column;
        border-radius: 16px;
        flex: auto;
        padding: 0;
        text-align: left;
        overflow: hidden;
        > .el-form {
          > .el-form-item {
            > .el-form-item__content {
              > .el-input,
              .el-select {
                width: 350px;
              }
            }
          }
        }

        > .footer {
          flex: none;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px 0 40px 0;
          > .el-button {
            width: 135px;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>
